module.exports = __webpack_public_path__ + "img/business_2.73e7ec72.jpg";